import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../http/query-client';
import {BackendResponse} from '../../http/backend-response/backend-response';
import {PaginatedBackendResponse} from '../../http/backend-response/pagination-response';
import {Product} from '../product';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {isTenantHost} from './pricing-path';

const endpoint = 'billing/products';
const tenantEndpoint = 'tenant/products';

export interface FetchProductsResponse extends BackendResponse {
  products: Product[];
}

interface UseProductsOptions {
  loader?: string;
  forceTenant?: boolean;
  forceUser?: boolean;
}

export function useProducts(options?: UseProductsOptions) {
  const {loader, forceTenant, forceUser} = options || {};
  const tenantMode = forceTenant ? true : forceUser ? false : isTenantHost();
  const path = tenantMode ? tenantEndpoint : endpoint;

  return useQuery<FetchProductsResponse>({
    queryKey: [path],
    queryFn: () => fetchProducts(tenantMode ? tenantEndpoint : endpoint),
    initialData: () => {
      // Only use bootstrap preloaded data on main (non-tenant) hosts
      if (!tenantMode && loader) {
        // @ts-ignore
        return getBootstrapData().loaders?.[loader];
      }
    },
  });
}

function fetchProducts(path: string): Promise<FetchProductsResponse> {
  return apiClient
    .get<PaginatedBackendResponse<Product>>(path)
    .then(response => {
      const data = (response as any).data;
      if ((data as any).pagination?.data) {
        return {products: (data as any).pagination.data};
      }
      return {products: (data as any).products};
    });
}
